import { FC } from 'react';
import { Grid, Box } from '@mui/material';
import { FiltersLayout, SearchField } from '../../../../components';

interface IOptionCategoryFilters {
  isLoading: boolean;
  searchValue: string;
  setSearchValue: (val: string) => void;
  handleSearch: (val: string) => void;
}

export const OptionCategoryFilters: FC<IOptionCategoryFilters> = ({
  isLoading,
  searchValue,
  setSearchValue,
  handleSearch
}) => {
  return (
    <FiltersLayout>
      <Grid item xs={12} sm={6} md={3}>
        <Box display="flex">
          <SearchField
            isDisabled={isLoading}
            placeholder="Search..."
            handleSearch={handleSearch}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        </Box>
      </Grid>
    </FiltersLayout>
  );
};
